<form nz-form [formGroup]="timesheetSearchForm">
  <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">

    <!-- Filter Items -->

    <div nz-col *ngIf="timesheetSearchForm.controls['Timeframe']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Timeframe'">
          <nz-select formControlName="Timeframe" class="filters" id="Timeframe" nzPlaceHolder="Timeframe" nzShowSearch
            style="width: 100%;">
            @for(opt of loopback; track $index) {
            <nz-option [nzLabel]="'Last ' + opt.label" [nzValue]="opt.val"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['status']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
      [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a status'">
          <nz-select formControlName="status" class="filters" id="status" nzPlaceHolder="Status" nzShowSearch
            nzAllowClear style="width: 100%;">
            @for(opt of statusList; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processStatusLkp']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Status'">
          <nz-select formControlName="processStatusLkp" class="filters" id="ProcessStatus"
            nzPlaceHolder="Process Status" nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of processStatusList; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processStatusLkup']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Status'">
          <nz-select formControlName="processStatusLkup" class="filters" id="ProcessStatus"
            nzPlaceHolder="Process Status" nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of filteredProcessStatusList; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['serviceDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a service date'">
          <!-- <nz-date-picker formControlName="serviceDate" id="serviceDate" nzPlaceHolder="Service Date"
            [nzFormat]="'MM/dd/yyyy'" nzShowSearch nzAllowClear style="width: 100%; height: 32px"></nz-date-picker> -->
          <ppl-date-picker formControlName="serviceDate" [id]="'serviceDate'" [showIcon]="true"
            [placeholder]="'Service Date'" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" style="width: 100%; display: block;">
          </ppl-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['servicePeriod']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a service period'">
          <nz-select formControlName="servicePeriod" class="filters" id="servicePeriod" nzPlaceHolder="Service Period"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of servicePeriods; track $index){
            <nz-option [nzLabel]="opt.servicePeriod" [nzValue]="opt.workWeekScheduleId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    @if(payPeriodMultipleSelection === 'multiple') {
    <div nz-col *ngIf="timesheetSearchForm.controls['payPeriod']" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="6" [nzXXl]="6" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a pay period'">
          <ppl-multiselect formControlName="payPeriod" id="payPeriod" class="filters" [options]="payPeriod"
            [disabled]="false" [showClear]="true" [placeholder]="'Pay Period'" [optionLabel]="'payPeriod'"
            style="width: 100%;" [optionValue]="'payrollId'" [maxTagCount]="1">
          </ppl-multiselect>
        </nz-form-control>
      </nz-form-item>
    </div>
    } @else {
    <div nz-col *ngIf="timesheetSearchForm.controls['payPeriod']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a pay period'">
          <nz-select formControlName="payPeriod" class="filters" id="payPeriod" nzPlaceHolder="Pay Period"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of payPeriod; track $index){
            <nz-option [nzLabel]="opt.payPeriod" [nzValue]="opt.payrollId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    <div nz-col *ngIf="timesheetSearchForm.controls['consumer']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Participant Name'">
          <input placeholder="Participant Name" nz-input (input)="onInput($event, 'consumer')"
            formControlName="consumer" id="consumer" />

        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['consumerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Participant PPL ID'">
          <input placeholder="Participant PPL ID" nz-input (input)="onInput($event, 'consumerPplId')"
            formControlName="consumerPplId" id="consumerPplId" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['provider']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter provider name'">
          <input placeholder="Provider Name" nz-input (input)="onInput($event, 'provider')" formControlName="provider"
            id="provider" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['providerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Provider PPL ID'">
          <input placeholder="Provider PPL ID" nz-input (input)="onInput($event, 'providerPplId')"
            formControlName="providerPplId" id="providerPplId" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['chequeNumber']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Check Number '">
          <input placeholder="Check Number" nz-input (input)="onInput($event, 'checkNumber')"
            formControlName="chequeNumber" id="checkNumber" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['crmNumber']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter CRM Number'">
          <input placeholder="CRM Number" nz-input (input)="onInput($event, 'crmNumber')"
            formControlName="crmNumber" id="crmNumber" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['serviceCode']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="5" [nzXXl]="5" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Service Code'">
          <nz-select formControlName="serviceCode" class="filters" id="payPeriod" nzPlaceHolder="Service Code"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of timesheetServiceCodes; track $index){
            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processCode'] && processCodes" [nzXs]="24" [nzSm]="12" [nzMd]="8"
      [nzLg]="4" [nzXl]="5" [nzXXl]="5" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Code'">
          <nz-select formControlName="processCode" class="filters" id="processCode" nzPlaceHolder="Process Code"
            nzShowSearch nzAllowClear style="width: 100%;">
            @for(opt of processCodes; track $index){
            <nz-option [nzLabel]="opt.displayName" [nzValue]="opt.processCodeDetailId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Search Button (Always aligned right) -->
    <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
      style="text-align: right; margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <div style="display: flex; gap: 8px; align-items: center; flex-wrap: nowrap;">
          <ppl-button label="Search" icon="fa fa-filter" [styleString]="'margin-top: -2px;'"
            [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="search()">
          </ppl-button>
          @if(export) {
          <ppl-button label="Export" icon="fa fa-download" [styleString]="'margin-top: -2px;'"
            [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="exportToExcel()"
            [disabled]="!isSearched"
            *authorize="[pageId, tabId, 'Export', 'section', 'read']"></ppl-button>
          }
        </div>
      </nz-form-item>
    </div>



  </div>
  <div class="alert alert-danger" *ngIf="showErrors"><strong>Error:</strong> Please enter provider PPL id and consumer
    PPL id</div>
</form>